import * as React from "react";
import assets from "../assets";

export interface IBoneIconProps {
  style?: any;
}

export const BoneIcon: React.FunctionComponent<IBoneIconProps> = ({ style = {} }) => {
  return (
    <i style={{ ...style, display: "flex", alignItems: "center" }}>
      <img src={assets.images.boneIcon} style={{ height: 16, width: 16 }} alt="boneIcon" />
    </i>
  );
};
